import React from 'react';
import { Container } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import ReportsMenu from '../../components/reports/shared/reports-menu';

function ReportsMenuPage() {
  const { reference } = useParams();

  return (
    <Container className="w-50 pt-5">
      <ReportsMenu reference={reference} />
    </Container>
  );
}

export default ReportsMenuPage;
